import classNames from 'classnames';
import { Button } from 'primereact/button';

import styles from './styles.module.scss';

type Props = {
    closeModal: () => void;
};

export const InfoModal = ({ closeModal }: Props) => {
    return (
        <div className={classNames(styles.infoModalWrapper)}>
            <h2>Согласие на сохранение платежных реквизитов</h2>
            <p>При следующей оплате вводить данные не потребуется - списание произойдет автоматически.</p>
            <p>
                Сохраняя способ оплаты, Вы соглашаетесь на его автоматическую привязку к вашей учетной записи для
                списания средств при продлении услуг на нашей платформе.
            </p>
            <p>
                Все данные хранятся в зашифрованном виде. Вы можете в любой момент отвязать способ оплаты и отключить
                автосписание в личном кабинете.
            </p>
            <Button label={'Продолжить'} onClick={closeModal} />
        </div>
    );
};
